export class EstimatedReleaseSchedule {

  id!: number;
  entityId!: string;
  quantity!: number;
  shipDate!: string;
  externalNotes!: string;
  internalNotes!: string;
  updateUser!: string;
  updateTimestamp!: string;

}
